// removed by extract-text-webpack-plugin
module.exports = {"bread-crumbs":"theme--bread-crumbs--ypysxNBl","breadCrumbs":"theme--bread-crumbs--ypysxNBl"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/BreadCrumbs/theme.scss
// module id = 1201
// module chunks = 0